import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ExportFileService {
  #httpClient = inject(HttpClient);

  #apiUrl = environment.apiUrl;

  exportFile(ids: string[], fields: string[]) {
    return this.#httpClient.put(
      this.#apiUrl + '/equipment/export',
      {
        ids,
        fields,
      },
      { responseType: 'blob' },
    );
  }
}
